(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ra-quick-filters"] && !Shopify.designMode) return;
  try {
    const setRareAgaveQuickFilterState = () => {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    const minimum = params.get('filter.v.price.gte');
    const maximum = params.get('filter.v.price.lte');
    const activePathTags = currentUrl.pathname.split('/').flatMap((segment) => decodeURIComponent(segment).split('+'));
    const additiveFreeIsActive = activePathTags.includes('additive-free');
    let activePriceFilter = '';

    if (minimum === null && Number(maximum) === 50) activePriceFilter = 'under-50';
    else if (Number(minimum) === 50 && Number(maximum) === 100) activePriceFilter = '50-100';
    else if (Number(minimum) === 100 && maximum === null) activePriceFilter = '100-plus';

    document.querySelectorAll('[data-ra-quick-filters]').forEach((filterGroup) => {
      filterGroup.querySelectorAll('[data-ra-filter="additive-free"]').forEach((tagLink) => {
        const tagUrl = new URL(tagLink.href, window.location.origin);
        for (const key of new Set(params.keys())) tagUrl.searchParams.delete(key);
        for (const [key, value] of params.entries()) tagUrl.searchParams.append(key, value);
        tagLink.href = tagUrl.toString();
        if (additiveFreeIsActive) tagLink.setAttribute('aria-current', 'true');
        else tagLink.removeAttribute('aria-current');
      });

      const priceTargets = {
        'under-50': { min: null, max: '50' },
        '50-100': { min: '50', max: '100' },
        '100-plus': { min: '100', max: null },
      };

      Object.entries(priceTargets).forEach(([filterName, range]) => {
        filterGroup.querySelectorAll(`[data-ra-filter="${filterName}"]`).forEach((priceLink) => {
          const priceUrl = new URL(currentUrl.href);
          priceUrl.searchParams.delete('filter.v.price.gte');
          priceUrl.searchParams.delete('filter.v.price.lte');
          if (filterName !== activePriceFilter) {
            if (range.min !== null) priceUrl.searchParams.set('filter.v.price.gte', range.min);
            if (range.max !== null) priceUrl.searchParams.set('filter.v.price.lte', range.max);
            priceLink.removeAttribute('aria-current');
          } else {
            priceLink.setAttribute('aria-current', 'true');
          }
          priceLink.href = priceUrl.toString();
        });
      });

      filterGroup.querySelectorAll('[data-ra-mobile-price]').forEach((select) => {
        select.value = activePriceFilter;
      });
    });
  };

  const navigateMobileFilter = (event) => {
    const select = event.target;

    if (select.matches('[data-ra-mobile-direct-filter]')) {
      if (select.value) window.location.href = select.value;
      return;
    }

    if (select.matches('[data-ra-mobile-price]')) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('filter.v.price.gte');
      currentUrl.searchParams.delete('filter.v.price.lte');

      if (select.value === 'under-50') currentUrl.searchParams.set('filter.v.price.lte', '50');
      if (select.value === '50-100') {
        currentUrl.searchParams.set('filter.v.price.gte', '50');
        currentUrl.searchParams.set('filter.v.price.lte', '100');
      }
      if (select.value === '100-plus') currentUrl.searchParams.set('filter.v.price.gte', '100');

      window.location.href = currentUrl.toString();
    }
  };

  const closeRareAgaveDirectFilters = (event) => {
    document.querySelectorAll('[data-ra-direct-filter][open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  };

  setRareAgaveQuickFilterState();
  document.addEventListener('change', navigateMobileFilter);
  document.addEventListener('click', closeRareAgaveDirectFilters);
  document.addEventListener('shopify:section:load', setRareAgaveQuickFilterState);
  document.addEventListener('shopify:section:reorder', setRareAgaveQuickFilterState);
  window.addEventListener('popstate', setRareAgaveQuickFilterState);
  } catch(e) { console.error(e); }
})();

})();
